import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { FaqList } from '../../../../components/web/faq/list/faq-list';
import { Container } from '../../../../components/web/container/container';
import { Headline } from '../../../../components/app/headline/headline';
import { WebButton } from '../../../../components/web/button/web-button';
import { IconNext } from '../../../../components/app/icons/next';

interface FaqTopProps {
    title?: string;
    itemsKey?: string;
    footer?: React.ReactNode;
}

export const FaqTop: React.FC<FaqTopProps> = ({ title, itemsKey = 'pages.homepage.faq.items', footer }) => {
    const { t } = useTranslation();

    return (
        <section className="relative isolate overflow-hidden py-large md:pt-xxlarge md:pb-[15rem] xxl:pt-[14rem]">
            <div
                aria-hidden="true"
                className="pointer-events-none absolute -left-[36rem] top-[-12rem] -z-[1] h-[65rem] w-[100rem] rotate-[12deg] bg-[url('/images/marketing/monery-hero-ribbon-mobile-800.webp')] md:bg-[url('/images/marketing/monery-hero-ribbon-mobile-1280.webp')] vl:bg-[url('/images/marketing/monery-hero-ribbon-v3.png')] bg-cover bg-center opacity-[0.25] [mask-image:radial-gradient(ellipse_at_center,black,transparent_68%)] xxl:-left-[30rem] xxl:h-[90rem] xxl:w-[140rem]"
            />
            <Container>
                <div className="mb-small md:mb-xxlarge">
                    <Headline level="1" tag="h2" gap="large" align="center">
                        {title ?? t('pages.homepage.faq.title')}
                    </Headline>
                </div>
                <div className="mx-auto max-w-[90rem]">
                    <FaqList itemsKey={itemsKey} />
                    <div className="pt-xlarge text-center">
                        {footer ?? (
                            <WebButton
                                tone="neutral"
                                href="/faq"
                                icon={<IconNext />}
                                variant="secondary"
                                variation="outlined"
                            >
                                {t('pages.faq.more')}
                            </WebButton>
                        )}
                    </div>
                </div>
            </Container>
        </section>
    );
};
